import { css } from '@emotion/css'
import { breakpoint, mediaQueryHelper, shorthandHelper, spacing } from '@offerzen/pinata-shame'

const styles = {
  recommendedList: css({
    marginTop: spacing.extraLarge,
    marginBottom: spacing.extraLarge,

    [mediaQueryHelper(breakpoint.tablet, 'max-width')]: {
      padding: shorthandHelper([0, spacing.default]),
    },
  }),

  notification: css({
    marginBottom: spacing.medium,
  }),
}

export default styles
